<mat-chip-listbox multiple [selectable]="!isDisabled">
  @for (chip of data; track chip) {
    <mat-chip-option class="chip_margin" [selectable]="!isDisabled" [selected]="isSelected(chip)" (click)="onClick($event, chip)" [title]="chip[titleField]" [disabled]="isDisabled">
      <span class="unselectableText">{{!textField ? chip : chip[textField]}}</span>
    </mat-chip-option>
  }
</mat-chip-listbox>
